import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.input`
${({ displayState }) => css`
        display: block;
        width: 100%;
        height: 2.429em;
        padding: 0.375rem 0.75rem;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.5;
        outline: none;
        color: #555555;
        background-color: #fff;
        background-clip: padding-box;
        border: ${displayState?.isBorder === 'no' ? 'none' : '1px solid #e4e6eb'};
        border-radius: 4px;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    `}
`;


export default Atom({ type: 'keyInput', dataType: ['string', 'number'], template })